module.exports = __webpack_public_path__ + "img/dashboard.16f0f783.svg";